import React from 'react';
import PropTypes from 'prop-types';

import PageContainer from 'shared-components/PageContainer/PageContainer';
import styles from './ClosedSocialLayout.module.css';

const PreSaleLayout = ({ children }) => (
  <PageContainer className={styles.container}>{children}</PageContainer>
);

PreSaleLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PreSaleLayout;
